import { DEFAULT_UI_FILTER, OPERATOR_TYPES } from './dashboardConsts';

/**
 * Adds tags to query filters that have display names
 * @param {Array} queryFilters - Array of filter objects with {field, operator, values}
 * @param {Array} allFilters - Array of filter field objects with name and values array
 * @returns {Array} Array of filter objects with {field, operator, tags}
 */
export function getFiltersWithTags(queryFilters, allFilters) {
    if (!queryFilters || !queryFilters.length) {
        return [DEFAULT_UI_FILTER];
    }

    return queryFilters
        .map(queryFilter => {
            if (queryFilter.field === 'default') {
                return DEFAULT_UI_FILTER;
            }

            const filterObj = allFilters.find(x => x.name === queryFilter.field);
            if (!filterObj) {
                return null;
            }

            return {
                field: filterObj,
                operator: OPERATOR_TYPES.find(x => x.name === queryFilter.operator),
                tags: queryFilter.values.map(v => filterObj.values.find(x => x.name === v)).filter(v => v),
            };
        })
        .filter(x => x !== null);
}
